<template>
  <modal
    v-model="show"
    :show-cancel-btn="true"
    :show-confirm-btn="false"
    text-cancel="закрыть"
    :style-popup="'width: 30vw;'"

    @cancel="closeModal"
    @close="closeModal"
  >
    <div slot="header">
      <div class="form-block__header">
        <div class="form-block__title">
          <h3>{{tur.tur_name}}</h3>
        </div>
      </div>
    </div>
    <div slot="content" style="display: block; position: relative; width: 100%;">
      <h4 style="color: #00541a;"><b>Ваша заявка успешно отправлена!</b></h4>

      <p><b>Для подтверждения заказа наш менеджер свяжется с вами в ближайшее время.</b></p>
      <br>
      <p>Если вы желаете связаться с менеджером по данному туру, пожалуйста воспользуйтесь контактами ниже</p>
      <br>
      <p v-html="tur.top_contacts"></p>
      <div v-for="(manager, managerIndex) in tur.managers_list" :key="managerIndex">
        <ul>
          <li><b>Менеджер:</b> {{manager.name + ' ' + manager.lastname}}</li>
          <li><b>Email:</b> <a :href="'mailto:' + manager.email">{{manager.email}}</a></li>
          <li><b>Skype:</b> <a :href="'skype:' + manager.skype">{{manager.skype}}</a></li>
          <li><b>Добавочный:</b> ({{manager.phone}})</li>
        </ul>
        <hr v-if="managerIndex > 0">
      </div>
    </div>
  </modal>
</template>

<script>
	import modal from './../Modal';
	export default {
		name: "ModalSuccess",
		components: {
			modal
		},
		props: {
			tur: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				show: true
			}
		},
		methods: {
			closeModal() {
				this.localShowModal = false;
				this.$emit('cancel', this.localShowModal)
			}
		}
	}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/Components/Modal/Success.vue